const prefix = "LEVY_COLLECTION_OVERRIDES_";

export const COPY = prefix + "COPY";
export const EDIT_DELETE = prefix + "EDIT_DELETE";
export const EDIT_GET = prefix + "EDIT_GET";
export const EDIT_SAVE = prefix + "EDIT_SAVE";
export const GET_CANDIDATES_FOR_COPYING = prefix + "GET_CANDIDATES_FOR_COPYING";
export const GET_ALL = prefix + "GET_ALL";
export const LIST = prefix + "LIST";
export const LIST_NEXT_PAGE = prefix + "LIST_NEXT_PAGE";
export const LIST_PREVIOUS_PAGE = prefix + "LIST_PREVIOUS_PAGE";
export const EXPORT = prefix + "EXPORT";
